module.exports = "/assets/side-events-listing/banner-mobile.png?VfkExtM";